<ul class="ap-header__navigation" role="menu">
    @for (navigationItem of navigationItems(); track navigationItem; let last = $last) {
        <li class="ap-header__horizontal-navigation-item" role="menuitem" data-testid="header-horizontal-menu-items">
            <ap-menu-item [navigationItem]="navigationItem" (navigationClicked)="navigationClicked.emit($event)"> </ap-menu-item>
            @if (navigationItem.children) {
                <ap-horizontal-menu-popover
                    [navigationItem]="navigationItem"
                    [lastItem]="last"
                    (navigationClicked)="navigationClicked.emit($event)"
                >
                </ap-horizontal-menu-popover>
            }
        </li>
    }
</ul>
@if (isLoggedIn() !== null && isLoggedIn() !== undefined) {
    <ap-horizontal-menu-user
        [isLoggedIn]="isLoggedIn()"
        [profileMenu]="profileMenu()"
        (loginLogout)="loginLogout.emit($event)"
        (itemClicked)="profileItemClicked.emit($event)"
        data-testid="header-horizontal-menu-user"
    >
    </ap-horizontal-menu-user>
}
